import Select from "react-select"
import React, { Fragment } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  CardTitle,
  Label,
} from "reactstrap"
export const Filters = props => {
  const {
    item,
    setItem,
    options,
    filterLabel,
    fromDate = "",
    toDate = "",
    setFromDate = () => {},
    setToDate = () => {},
    showToDate = true,
    setFiltersData = () => {},
  } = props
  const handleSubmit = e => {
    e.preventDefault()
    setFiltersData({
      item: item,
      fromDate: fromDate,
      toDate: toDate,
    })
  }
  return (
    <Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4"></CardTitle>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Row>
                <Col lg={5}>
                  <div className="row mb-4">
                    <Col sm={9} md={2} lg={2}>
                      <Label
                        htmlFor="horizontal-firstname-Input"
                        className="col-sm-3 col-form-label text-nowrap"
                      >
                        From
                      </Label>
                    </Col>
                    <Col sm={3} md={6} lg={10}>
                      <Input
                        type="date"
                        className="form-control"
                        id="horizontal-firstname-Input"
                        onChange={e => {
                          setFromDate(e.target.value)
                        }}
                        value={fromDate}
                      />
                    </Col>
                  </div>
                </Col>
                <Col lg={5}>
                  <div className="row mb-4">
                    <Col sm={9} md={2} lg={2}>
                      <Label
                        htmlFor="horizontal-email-Input"
                        className="col-sm-3 col-form-label text-nowrap"
                      >
                        To
                      </Label>
                    </Col>
                    <Col sm={9} md={6} lg={10}>
                      <Input
                        type="date"
                        className="form-control"
                        id="horizontal-email-Input"
                        onChange={e => {
                          setToDate(e.target.value)
                        }}
                        value={toDate}
                      />
                    </Col>
                  </div>
                </Col>

                <Col lg={2}>
                  <div className="row mb-4">
                    <Col sm={9} md={2} lg={2}></Col>
                    <Col sm={9} md={6} lg={10}>
                      <div>
                        <Button type="submit" color="primary" className="w-md" onClick={() => {
                          props.call()
                        }}>
                          Submit
                        </Button>
                      </div>
                    </Col>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Fragment>
  )
}
